import domReady from '@wordpress/dom-ready';
import AnnouncementModal from './components/announcement-modal';

domReady( () => {
	new AnnouncementModal().init();
} );
